(ns assemble.component.file-tree.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            [reitit.frontend :as reitit]
            [uix.core :refer [$ defui]]))

(defui expand-icon []
  ($ :<>
     ($ Icon
        ;; Used to check if clicking expand/collapse icon directly
        {:data-expand 1
         :sx #js {:color "grey.40"}}
        "chevron_right")
     ($ Icon
        {:sx #js {:color "grey.40"}}
        "folder_open")))

(defui collapse-icon []
  ($ :<>
     ($ Icon
        {:data-expand 1
         :sx #js {:color "grey.40"}}
        "expand_more")
     ($ Icon
        {:sx #js {:color "grey.40"}}
        "folder_open")))

(defui folder-icon-wide []
  ($ Icon
     ;; Match icon width for expand/collapse
     {:sx #js {:ml 2.5
               :color "grey.40"}}
     "folder_open"))

(defui tree-skeleton []
  ($ Stack
     {:direction "column"
      :sx #js {:px 3
               :py 2
               :gap 4}}
     ($ Skeleton)
     ($ Skeleton)))

(def TreeContext (react/createContext))
(def TreeContextProvider (.-Provider TreeContext))

;; Because the state is passed in from the outside, these components
;; aren't tied to the Re-frame state.

(defui file-tree-context
  {:arglists '([{:keys [node->id node->label expanded toggle selected chilren]}])}
  [{:keys [children] :as root-props}]
  ($ TreeContextProvider
     {:value root-props}
     children))

(defui tree-item
  "Render tree node and its children.

  Uses state from file-tree-context.

  Children are hard-coded to use their parents href and to replace `node` query
  parameter with their own id."
  [{:keys [node href parent-path]}]
  (let [{:keys [children]} node
        {:keys [expanded toggle selected node->id node->label]} (react/useContext TreeContext)
        path (conj (or parent-path []) (node->id node))
        id (node->id node)]
    ($ Box
       ($ Box
          {:component "a"
           :href href
           :sx (fn [^js theme]
                 #js {:display "flex"
                      :color "text.primary"
                      :textDecoration "none"
                      :py 2
                      :px 1
                      :alignItems "center"
                      :backgroundColor (when (= selected id)
                                         "primary.selected")
                      "&:hover" #js {:backgroundColor (if (= selected id)
                                                        "primary.200"
                                                        (.. theme -palette -action -hover))}})}
          ($ Box
             {:onClick (fn [e]
                         ;; Prevent item click on collapse/expand
                         (.preventDefault e)
                         (.stopPropagation e)
                         (toggle path))
              :sx #js {:display "flex"
                       :justifyContent "center"
                       :mr 1}}
             (if (seq children)
               (if (get-in expanded path)
                 ($ collapse-icon)
                 ($ expand-icon))
               ($ folder-icon-wide)))
          ($ Typography
             {:component "div"
              :noWrap true}
             (node->label node)))
       (when (seq children)
         ($ Collapse
            {:in (boolean (get-in expanded path))}
            ($ Box
               {:sx #js {:ml 2}}
               (for [child children]
                 ($ tree-item
                    {:key (node->id child)
                     :node child
                     ;; Add or replace ?node= parameter
                     ;; This could be made more generic
                     :href (reitit/set-query-params href {:node (node->id child)})
                     :parent-path path}))))))))
